import styled, { css } from 'styled-components';
import { Picture } from '../../../../picture';
import Video from '../../../../video';
import { pxToRem } from '../../../../../design-tokens/style-utilities';
/**
 * PanelMediaBorderMixin
 */
export const panelMediaMixinStyles = ({ theme }) => css `
	border-radius: 0;
	border-top-left-radius: ${pxToRem(Number(theme.borderRadius.m) - Number(theme.borderWidth['2']))};
	border-top-right-radius: ${pxToRem(Number(theme.borderRadius.m) - Number(theme.borderWidth['2']))};
	margin-bottom: 0;
	margin-top: 0;
	transform: translate3d(0, 0, 0);
`;
export const PanelMediaBorderMixin = styled.div `
	${panelMediaMixinStyles}
`;
/**
 * PanelMediaContainer
 */
export const panelMediaContainerStyles = () => css `
	display: block;
`;
export const PanelMediaContainer = styled.div `
	${panelMediaContainerStyles}
`;
/**
 * PanelMediaLinkWrapper
 */
export const panelMediaLinkWrapperStyles = () => css `
	display: block;
	text-decoration: none;
`;
export const PanelMediaLinkWrapper = styled.a `
	${panelMediaLinkWrapperStyles}
`;
/**
 * PanelMediaVideo
 */
export const panelMediaVideoStyles = () => css `
	iframe {
		${panelMediaMixinStyles}
	}
`;
export const PanelMediaVideo = styled(Video) `
	${panelMediaMixinStyles}
	${panelMediaVideoStyles}
`;
/**
 * PanelMediaImage
 */
export const panelMediaImageStyles = () => css `
	aspect-ratio: 16 / 9;
	object-fit: cover;
`;
export const PanelMediaImage = styled(Picture.Image) `
	${panelMediaMixinStyles}
	${panelMediaImageStyles}
`;
export const panelMediaContentStyles = ({ theme }) => css `
	position: relative;
	z-index: 1;
	top: ${pxToRem(theme.spacing['200'])};
	left: ${pxToRem(theme.spacing['200'])};

	> * {
		position: absolute;
	}
`;
export const PanelMediaContentContainer = styled.span `
	${panelMediaContentStyles}
`;
